import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { getThemeData } from "@hzero-front-ui/core";
export var getDropdownItemCss = function getDropdownItemCss(props) {
  var _getThemeData = getThemeData(props, "select"),
    fontFamily = _getThemeData.fontFamily,
    dropdownItemFontSize = _getThemeData.dropdownItemFontSize,
    activeBgColor = _getThemeData.activeBgColor,
    activeFontWeight = _getThemeData.activeFontWeight,
    hoverBgColor = _getThemeData.hoverBgColor;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-size: ", "px;\n    &-selected,\n    &:hover {\n      background: ", ";\n      font-weight: ", ";\n    }\n    &-active {\n      background: ", ";\n    }\n  "])), fontFamily, dropdownItemFontSize, activeBgColor, activeFontWeight, hoverBgColor);
};